export default __webpack_public_path__ + "static/media/line6.e27c4c82.svg";